export const COMPANY = 'COMPANY';
export const USER = 'USER';
export const DIRECTION = 'DIRECTION';
export const SEARCH_QUERY = 'SEARCH_QUERY';
export const INVOICES_PAGE = 'INVOICES_PAGE';
export const INVOICES_YEAR = 'INVOICES_YEAR';
export const INVOICES_SORT = 'INVOICES_SORT';
export const PO_SORT = 'PO_SORT';

